import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon, BookOpenIcon, GiftIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const pillars = [{
  icon: BookOpenIcon,
  tag: 'Incluido 📚',
  title: 'Colección "Los 7 Objetos de Oro" (5 Tomos)',
  value: '69€',
  today: 'Hoy: Incluido',
  lead: 'Todo lo que necesitas para facturar tus primeros 500€/mes.',
  items: ['El Radar Montessori: Cómo dominar el mercado infantil que crece +18% anual en España. Torres de aprendizaje, triángulos Pikler, estanterías infantiles.', 'Decoración "Slim" & Lifestyle: Soportes de laptop minimalistas, estantes flotantes hexagonales, organizadores de escritorio premium. Se venden en 24h.', 'El Lujo en la Cocina: Tablas gourmet que transforman tus sobras de roble o nogal en 40-80€. End-grain, diseño nórdico, acabado profesional.', 'El Arte del Acabado Premium: Cómo hacer que cualquier madera parezca de revista. Aceites orgánicos, técnicas de cera, color y textura que hipnotiza.', 'Ventas de Guerrilla: Domina Wallapop e Instagram España. Scripts listos. Fotos que venden. Cómo no regatear. Cómo cerrar.']
}, {
  icon: GiftIcon,
  tag: 'Incluido 💪',
  title: '5 Bonos Estratégicos Gratuitos',
  value: '89,50€',
  today: 'Hoy: Incluido',
  lead: 'Los recursos que hacen que el kit funcione desde la primera venta.',
  items: ['Guía de Precios "España": Cuánto cobrar en tu zona para ganar dinero de verdad después de gastos.', 'Plantillas "Copia y Pega": 30+ anuncios redactados que desactivan el regateo automáticamente.', 'Directorio de Proveedores: Dónde compramos los profesionales en España sin que nos claven.', 'Radar de Demanda Local ⭐ NUEVO: Valida en 15 minutos si un producto merece fabricarse antes de gastar madera.', 'Pack Cliente Feliz ⭐ NUEVO: Convierte cada entrega en experiencia premium que genera reseñas y recomendaciones.']
}];
export function WhatYouGet() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-231" data-mp="22jby27ooy30u">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-232" data-mp="1xj658o6oqah6">
        <SectionTag icon="🎁" data-id="element-233" data-mp="1xl0nfuqknohk">Lo que recibes hoy (Acceso Inmediato)</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-234" data-mp="2bbdw5zbaf77y">
          Todo lo que necesitas, en un solo lugar.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-235" data-mp="2l88r688cqphh">
          Todo lo que necesitas para facturar tus primeros 500€/mes.
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-6 px-4 sm:px-6 lg:grid-cols-2" data-id="element-236" data-mp="2gc1oqpf5zw4a">
        {pillars.map((pillar, i) => <m.div key={pillar.title} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: i % 2 * 0.1
      }} className="flex flex-col rounded-2xl border border-brown/20 bg-white p-6 shadow-card sm:p-7" data-id="element-237" data-mp="2q7br5e9h65il" data-mpi={i}>
            <div className="flex items-start justify-between gap-3" data-id="element-238" data-mp="lrzz78llqr79">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-brown/10" data-id="element-239" data-mp="pqz3cqziejxn">
                <pillar.icon size={22} className="text-brown" data-id="element-240" data-mp="bzu0lg0uhbj3" />
              </div>
              <span className="rounded-full bg-ink/5 px-3 py-1 text-xs font-semibold text-muted" data-id="element-241" data-mp="gxvqokwoub42">
                {pillar.tag}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-ink sm:text-xl" data-id="element-242" data-mp="71iqr5ajv10v">
              {pillar.title}
            </h3>
            <div className="mt-2 flex items-baseline gap-2 text-sm" data-id="element-243" data-mp="3p86wmxdfbs7l">
              <span className="text-muted line-through" data-id="element-244" data-mp="3u6qgms8gitxb">Valor: {pillar.value}</span>
              <span className="font-semibold text-success" data-id="element-245" data-mp="1nepq5x114xef">{pillar.today}</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-246" data-mp="1sevkxm2lj00q">{pillar.lead}</p>
            <ul className="mt-4 space-y-2.5" data-id="element-247" data-mp="3ohgutm3ywtx9">
              {pillar.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-ink/90" data-id="element-248" data-mp="3jidwslmennys">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-249" data-mp="3ejatp6pzjrtg" />
                  <span data-id="element-250" data-mp="3el5eml19bjxj">{item}</span>
                </li>)}
            </ul>
          </m.div>)}
      </div>
    </section>;
}